module.exports = "/static/media/sms_enrollment_numbers_assigning.eb80edca.png";